import { render, staticRenderFns } from "./relevance-query.vue?vue&type=template&id=1df4f5c3&"
import script from "./relevance-query.vue?vue&type=script&lang=js&"
export * from "./relevance-query.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports